import { MobileProps } from "src/hooks/useIsMobile";
import { colors } from "src/styles";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 40px;
`;

const EmptyContainer = styled.div`
  width: 100%;
  min-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NoTicketsMessage = styled.h4<MobileProps>`
  text-align: left;
  margin-top: 10px;
  background-color: ${colors.grey.light14};
  padding: 10px;
  border-radius: 0;
  border: 1px solid ${colors.grey.light3};
  font-size: 13px;
  font-weight: 400;
  color: ${colors.grey.dark3};
`;

const PaginationContainer = styled.div`
  margin-top: 32px;
`;

export { Container, EmptyContainer, NoTicketsMessage, PaginationContainer };
